<template>
  <div class="row" style="margin-top: 40px;">
    <!--General Top Bar -->
    <!-- <general-top-bar :title="$t('pages.feedback')"></general-top-bar> -->
    <!--End General Top Bar -->
    <div class="col-md-12 ">
      <div class="search-bar no-margin">
        <div class="col-sm-12 no-padding">
          <div class="pull-left">
            <el-input v-model="search" @input="onInput()" :placeholder="$t('feedback.search')" class="icon-search"></el-input>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-content row">
          <data-tables class="feedback-table width-table"
              v-loading="loading"
              :data="tableData"
              :search-def="defaultSearchDef()"
              :action-def="defaultActionDef()"
              :pagination-def="paginationDef"
              :table-props="{'row-class-name': rowClass, 'border': false}"
              @row-click="goToRecord"
              style="width: 100%">
            <el-table-column
              :min-width="40"
              prop="type"
              :label="$t('feedback.type')">

              <template slot-scope="props">
                <span class="label" :class="'label-' + feedbackTypeClass(props.row.type)" >{{$t('feedbackTypes.' + props.row.type)}}</span>
              </template>
            </el-table-column>
            <el-table-column
              :min-width="60"
              prop="sent_by"
              :label="$t('feedback.sentBy')">
              <template slot-scope="props">
                <template v-if="props.row.firstname && props.row.lastname">
                  {{props.row.firstname}} {{props.row.lastname}}
                </template>
                <template v-else>{{props.row.email}}</template>
              </template>
            </el-table-column>
            <!-- <el-table-column
              :min-width="40"
              prop="text"
              :label="$t('feedback.text')">
              <template slot-scope="props">
                {{limitChars(props.row.text, 50)}}
              </template>
            </el-table-column> -->
            <el-table-column
              :min-width="40"
              prop="text"
              :label="$t('customers.location')">
              <template slot-scope="props">
                {{props.row.location}}
              </template>
            </el-table-column>
            <el-table-column
              :min-width="40"
              prop="seen"
              :label="$t('feedback.seen')">
              <template slot-scope="props">
                {{props.row.seen ? 'seen' : 'new'}}
              </template>
            </el-table-column>
            <el-table-column
              :min-width="60"
              prop="created_at"
              :label="$t('feedback.sentAt')">
              <template slot-scope="props">
                {{formatDateTime(props.row.created_at)}}
              </template>
            </el-table-column>
            <el-table-column
              :width="160">
              <template slot-scope="props">
                <div class="edit">
                  <i class="fa fa-pencil"></i>{{$t('general.edit')}}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              :width="90">
              <template slot-scope="props"><i v-if="props.row.admin_response" class="fa fa-comment"></i></template>
            </el-table-column>
        </data-tables>
        <el-pagination
          class="active-pagination width-table"
          :total="paginationDef.totalRecords"
          :page-size="paginationDef.perPage"
          :pager-count="pagerCount"
          layout="prev, pager, next, total"
          @current-change="handlePageChange($event)"
          @prev-click="handlePageChange($event)"
          @next-click="handlePageChange($event)">
        </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Input, Select, Option} from 'element-ui'
  import DataTables from 'vue-data-tables'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  // import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  Vue.use(Input)
  Vue.use(Select)
  Vue.use(Option)
  Vue.use(DataTables)
  export default{
    components: {
      PPagination,
      // GeneralTopBar,
      PSwitch
    },
    computed: {
    },
    data () {
      return {
        loading: true,
        pagerCount: 5,
        paginationDef: {
          page: null,
          totalPages: null,
          totalRecords: null,
          show: true
        },
        propsToSearch: ['name', 'status', 'type', 'discount'],
        tableColumns: [],
        tableData: [],
        search: ''
      }
    },
    created: function () {
      // console.warn(this.$store.getters.loggedInUser)
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }
      this.getFeedback(data)
    },
    methods: {
      onInput () {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }

        if (this.search.length >= 3) {
          data.search = this.search
          this.getFeedback(data)
        }

        if (this.search.length === 0) {
          this.getFeedback(data)
        }
      },
      handlePageChange (page) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          page: page,
          perPage: this.paginationDef.perPage
        }
        if (this.search.length >= 3) {
          data.search = this.search
        }
        this.getFeedback(data)
      },
      getFeedback (data) {
        var self = this
        this.loading = true
        this.apiRequest('/feedback', 'GET', data, function (response) {
          if (response.status === true) {
            self.tableData = response.data.data
            self.paginationDef.page = response.data.pagination.page
            self.paginationDef.perPage = response.data.pagination.perPage
            self.paginationDef.totalPages = response.data.pagination.totalPages
            self.paginationDef.totalRecords = response.data.pagination.totalRecords
          }
          self.$nextTick(function () {
            self.loading = false
          })
        })
      },
      handleDelete (index, row) {
        var self = this
        var btnCounter = 3
        swal({
          text: `Are you sure you want to delete '${row.name}'?`,
          type: 'question',
          showCancelButton: true,
          confirmButtonText: self.$t('general.yes') + ' (' + btnCounter + ')'
        })
        .then((result) => {
          if (result) {
            this.apiRequest('/hello', 'GET', [], function (response) {
              // console.warn(response)
              if (response.status === true) {
                swal(
                  '',
                  'Push Notification deleted successfully',
                  'success'
                )
                self.tableData.splice(index, 1)
              } else {
                swal(
                  '',
                  'Something went wrong, please try again later...',
                  'error'
                )
              }
            })
          }
        })
        swal.disableConfirmButton()

        var btnInterval = setInterval(function () {
          btnCounter--

          if (btnCounter >= 1) {
            swal.getConfirmButton().textContent = 'Yes (' + btnCounter + ')'
          } else {
            swal.getConfirmButton().textContent = 'Yes'
            clearInterval(btnInterval)
            swal.enableConfirmButton()
          }
        }, 1000)
      },
      goToRecord (row, event, column) {
        this.globalGoToRecord(row, event, column, '/feedback/view/')
      },
      rowClass (row, index) {
        if (row.row.seen) {
          return ''
        } else {
          return 'new-feedback'
        }
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/Feedback/Feedback.vue